export default "__VITE_ASSET__bc56413b__"